import React, { useState } from "react";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./MasonryMedia.module.css";
import {
  coachDemoImg,
  DisableHeartIcon,
  DummyVideo,
  GalleryImg1,
  GalleryImg2,
  GalleryImg3,
  messageIcon,
  coachDemoImg2,
  VideoPlayIcon,
} from "../../constant/imagePath";
import ReactPlayer from "react-player/lazy";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Button, Col, Row } from "react-bootstrap";

export const MasonryMedia = ({ galleryData }) => {
  return (
    <div className={classes.masonry}>
      <Row>
        <Col md={12}>
          <Row>
            {galleryData?.map((item, index) => {
              const mediaType = item?.type?.split("/")[1];
              const isImage =
                mediaType === "png" ||
                mediaType === "jpeg" ||
                mediaType === "svg+xml";
              const isVideo =
                mediaType === "mp4" ||
                mediaType === "mov" ||
                mediaType === "avi";

              return (
                <>
                  <Col md={isVideo ? 12 : 6}>
                    {isVideo && (
                      <div className={classes.videoCard}>
                        <video
                          src={URL.createObjectURL(item)}
                          controls={true}
                        />
                      </div>
                    )}

                    {isImage && (
                      <div
                        className={`${classes.imageCard} ${
                          index == 0 && classes.img1
                        }`}
                      >
                        <img src={URL.createObjectURL(item)} />
                      </div>
                    )}
                  </Col>
                </>
              );
            })}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

MasonryMedia.defaultProps = {
  galleryData: [
    coachDemoImg2,
    GalleryImg1,
    GalleryImg1,
    GalleryImg1,
    coachDemoImg,
  ],
};

{
  /* <Row className="g-0">
<Col md={12} className={[classes.mb8, "p-0"].join(" ")}>
  <div className={classes.playerWrapper}>
    <ReactPlayer
      className={classes.player}
      url={galleryData?.videoURL}
      playing={playing}
      width="100%"
      height="100%"
      playIcon={messageIcon}
      playsinline
      controls={playing}
      onReady={true}
      onStart={() => setPlaying(true)}
      onPlay={() => setPlaying(true)}
      onPause={() => setPlaying(false)}
    />
    {playing === false && (
      <div className={classes.overlay}>
        <div
          className={classes.overlayIcon}
          onClick={() => setPlaying(true)}
        >
          <img src={VideoPlayIcon} />
        </div>
      </div>
    )}
  </div>
</Col>

<Col md={6}>
  <Row>
    {galleryData?.images?.slice(0, 2)?.map((image) => {
      return (
        <Col md={12} className={[classes.mb8].join(" ")}>
          <div className={classes.imageCard1}>
            <img src={image} />
          </div>
        </Col>
      );
    })}
  </Row>
</Col>
<Col md={6} className={[classes.pl8].join(" ")}>
  {galleryData?.images?.slice(2, 3)?.map((image) => {
    return (
      <div className={classes.imageCard2}>
        <img src={image} />
      </div>
    );
  })}
</Col>
</Row> */
}
